
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/institution-status",
      function () {
        return require("private-next-pages/docs/link/institution-status.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/institution-status"])
      });
    }
  